import { api } from "@/lib/api";

export const getJourney = async () => (await api.get("/journey")).data;
export const updateStep = async (key, body) =>
  (await api.post(`/journey/${key}`, body)).data;

export const adminListAllowlist = async () =>
  (await api.get("/admin/allowlist")).data;
export const adminAddEmail = async (email) =>
  (await api.post("/admin/allowlist", { email })).data;
export const adminRemoveEmail = async (email) =>
  (await api.delete(`/admin/allowlist/${encodeURIComponent(email)}`)).data;
export const adminListUsers = async () => (await api.get("/admin/users")).data;
export const adminUsersActivity = async () =>
  (await api.get("/admin/users-activity")).data;
export const adminUserDetail = async (userId) =>
  (await api.get(`/admin/users/${encodeURIComponent(userId)}/detail`)).data;

// View-as / impersonation
export const adminViewAs = async (targetUserId) =>
  (await api.post(`/admin/view-as/${encodeURIComponent(targetUserId)}`)).data;
export const adminStopViewAs = async () =>
  (await api.post("/admin/stop-view-as")).data;
export const adminViewAsStatus = async () =>
  (await api.get("/admin/view-as")).data;
